/**
 * Horário de atendimento do suporte.
 *
 * A versão anterior desta regra lia o relógio do computador do cliente, apesar
 * de a tela dizer "Horário de Brasília": quem estivesse em outro fuso via o
 * status errado. Aqui o horário é sempre o de São Paulo, venha de onde vier o
 * acesso.
 *
 * É o horário previsto, não a disponibilidade real — a API do TomTicket não
 * informa se há atendente conectado, nem conhece feriados ou pausas daqui.
 */

const FUSO = 'America/Sao_Paulo';

/** Os mesmos períodos exibidos no menu de ajuda. */
export const PERIODOS = [
  { inicio: 8, fim: 11.25 },  // 08:00 às 11:15
  { inicio: 13, fim: 17.25 }, // 13:00 às 17:15
];

/**
 * Dia da semana (0 = domingo) e hora decimal em São Paulo.
 */
const agoraEmSaoPaulo = () => {
  const partes = new Intl.DateTimeFormat('en-US', {
    timeZone: FUSO,
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(new Date());

  const valor = (tipo) => partes.find((p) => p.type === tipo)?.value;

  const dias = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  const hora = Number(valor('hour'));
  const minuto = Number(valor('minute'));

  return {
    diaSemana: dias[valor('weekday')],
    // 24 aparece no lugar de 0 em algumas combinações de locale e hour12.
    horaDecimal: (hora === 24 ? 0 : hora) + minuto / 60,
  };
};

/**
 * Informa se o suporte está dentro do horário de atendimento.
 *
 * @return {boolean}
 */
export const atendimentoAberto = () => {
  try {
    const { diaSemana, horaDecimal } = agoraEmSaoPaulo();

    if (!(diaSemana >= 1 && diaSemana <= 5)) return false;

    return PERIODOS.some(({ inicio, fim }) => horaDecimal >= inicio && horaDecimal <= fim);
  } catch {
    // Sem suporte a fuso no navegador: não afirma que está fechado.
    return true;
  }
};

export default atendimentoAberto;
